import { gql } from "@apollo/client";export default gql`mutation DeletePlanTagMap($ids: [Int!]) {
  delete_subscription_plan_tag_map(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
`;
